<template>
  <div class="main-content">
    <div class="project-list">
      <div 
        class="project-card"
        v-for="(project, index) in projects" 
        :key="index"
      >
        <div class="project-header">
          <span class="icon icon-purple"></span>
          <strong>{{ project.title }}</strong>
        </div>
        <p>{{ project.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      projects: []
    };
  },
  mounted() {
    this.fetchProjects();
  },
  methods: {
    async fetchProjects() {
      try {
        const response = await fetch("/program.json");
        this.projects = await response.json();
      } catch (error) {
        console.error("获取项目数据失败:", error);
      }
    }
  }
};
</script>

<style scoped>
.main-content {
  padding: 2rem;
  background-color: #f9f9f9;
}

.title {
  text-align: center;
  font-size: 2.5rem;
  color: #4a3f98;
  margin-bottom: 2rem;
}

.project-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.project-card {
  background-color: #fff;
  border-left: 5px solid #4a3f98;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.project-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.project-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.project-header strong {
  font-size: 1.2rem;
  color: #4a3f98;
}

.project-card p {
  color: #000000;
}

.icon-purple {
  font-size: 1.5rem;
  margin-right: 0.5rem;
  color: #4a3f98;
}
</style>
